
import { Grid, Card, CardMedia, CardContent, Typography, Box, LinearProgress, CardActionArea,Paper,Button } from '@mui/material';
import { Pie, Line } from "react-chartjs-2";
import { useEffect, useState } from "react";
import { investorApi } from "../../api/api";
import { vendorApi } from "../../api/api";
import api from '../../api/api';
import house  from "../../images/house.jpg";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import {  Co2Sharp, CurrencyRupee,Groups2, HomeRepairServiceOutlined, HouseOutlined, HouseRounded,  HouseSharp,} from "@mui/icons-material";
import { DataGrid } from '@mui/x-data-grid'; // Import DataGrid
import { useNavigate } from 'react-router-dom';


// Register Chart.js components
ChartJS.register(
  CategoryScale,
  ArcElement,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);
const pieData = {
  labels: ["Invested", "Remaining"],
  datasets: [
    {
      data: [25000, 10000], // €25,000 invested out of €35,000 total value
      backgroundColor: ["#4caf50", "#f44336"],
      hoverOffset: 4,
    },
  ],
};

// Dummy data for the chart
const chartData = {
  labels: ["October", "November", "December", "January"],
  datasets: [
    {
      label: "Investments",
      data: [5000, 6000, 7000, 6500],
      borderColor: "rgba(75, 192, 192, 1)",
      backgroundColor: "rgba(75, 192, 192, 0.2)",
      tension: 0.4,
    },
  ],
};

// Chart options
const chartOptions = {
  responsive: true,
  plugins: {
    legend: {
      display: true,
      position: "top",
    },
  },
};

// Chart options for pie chart
const pieOptions = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
      position: "bottom",
    },
  },
};
// Sample investment data
// const investData = [
//   { id: 1, PropertyName: 'belcy', Price: '20000', NoofInvester: '10', SqFts: '1000', CurrentValue: '100000', InvestedAmount: '20000' },
//   { id: 2, PropertyName: 'malathi', Price: '10000', NoofInvester: '5', SqFts: '100', CurrentValue: '100000', InvestedAmount: '1000' },
//   { id: 3, PropertyName: 'Pavika', Price: '10000000', NoofInvester: '3', SqFts: '3000', CurrentValue: '230000', InvestedAmount: '100000' },
//   { id: 4, PropertyName: 'lax', Price: '2000', NoofInvester: '7', SqFts: '2400', CurrentValue: '100000', InvestedAmount: '2000000' },
//   { id: 5, PropertyName: 'pavi', Price: '30000', NoofInvester: '4', SqFts: '1000', CurrentValue: '10000', InvestedAmount: '30000' },
// ];

// const filteredData = investData.map((item) => ({
//   id: item.id,
//   PropertyName: item.PropertyName,
//   Price: item.Price,
//   NoofInvester: item.NoofInvester,
//   SqFts: item.SqFts,
//   CurrentValue: item.CurrentValue,
//   InvestedAmount: item.InvestedAmount
// }));

const capitalizeName = (name) => {
  return name
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};
// Columns for DataGrid
const columns = [
  { field: "id", headerName: "ID", width: 70 },
  { field: "PropertyName", headerName: "Property Name", width: 200,
      renderCell: (params) => {
          return <span>{capitalizeName(params.value)}</span>; // Capitalize the name
        }
   },
  { field: "MarketPriceAtInvestment", headerName: "Price", width: 150 },
  { field: "NoofInvester", headerName: "No Of Investors", width: 120 },
  { field: "InvestedAmount", headerName: "Invested Amount", width: 150 },
  { field: "SizeInSqFt", headerName: "Square Fits", width: 150 },
  { field: "CurrentValue", headerName: "Current Value", width: 200 }
];



const Income = () => {
  const navigate = useNavigate();
  const [investmentData, setInvData] = useState([]);
  const [propertyData, setPropertyData] = useState([]);
  const [investor, setInvestor] = useState([]);
  
  useEffect(() => {
    const fetchData = async () => {
      try {
        const [investmentsResponse, propertiesResponse, investorResponse] = await Promise.all([
          investorApi.getRecentInvestmentProperties(),
          api.getAllProperties(),
          investorApi.getInvestmentStats()
        ]);
  
        setInvData(investmentsResponse.data);
        setPropertyData(propertiesResponse.data);
        setInvestor(investorResponse.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
  
    fetchData();
  }, []);
  const rows = investmentData.map(item => ({
    id: item.Pid, 
    ...item
  }));

  const [showAll, setShowAll] = useState(false); // State to track whether to show all properties

  const handleViewAllClick = () => {
    setShowAll((prevShowAll) => !prevShowAll); // Toggle the state
  };
  
  const propertiesToDisplay = showAll ? propertyData : propertyData.slice(0, 6);
  
  

  const handleCardClick = (property) => {
    if (property.type === 'project') {
      navigate(`/viewProject/viewProject?projectId=${property.id}`, {  // Use backticks here
        state: {
          ProjectId:property.id,
          ProjectName: property.name,
          City: property.city,
          Address:property.address,
          // NoOfPlots:property.noOfInvestors,
          AvailablePlots: property.AvailablePlots,
          IconUrl: property.iconUrl, 
        },
        


      });
    } else {
      navigate(`/property/viewProperty?propertyId=${property.id}`,{
        state:{
          PropertyId: property.id,
          PropertyName: property.name,
          City: property.city,
          // PropertyType: row.PropertyType,
          NoOfInvestors: property.noOfInvestors,
          InvestedAmount: property.InvestedAmount,
          ProjectName: property.ProjectName,
          Address: property.address,
          // SizeInSqFt: row.SizeInSqFt,
          // UnitPrice: row.UnitPrice,
          // waiting_period: row.waiting_period,
          // InvestmentType: row.InvestmentType,
          IconUrl: property.iconUrl,
          // InvestedUnit:row.InvestedUnit,
          // TokenSize:row.TokenSize
        }
      });
    }
  };
  



  return (
    <Box sx={{ padding: 3 }}>
    {/* Overview Cards */}
    <Grid container spacing={3}>
      <Grid item xs={6} md={3}>
        <Paper
          elevation={3}
          sx={{
            padding: 2,
            background: "linear-gradient(to bottom, #F3FAFD, #FFFFFF)",
            //   background: "#F3FAFD",
            display: "flex", // Use flexbox
            flexDirection: "column", // Align items in a column
            alignItems: "center", // Horizontally center the content
            justifyContent: "center", // Vertically center the content
            textAlign: "center", // Center-align text
          }}
        >
          <Box
            sx={{
              width: 70, // Diameter of the circle
              height: 70,
              borderRadius: "50%", // Makes it a circle
              backgroundColor: "#589FE3",
              boxShadow: "0 0 10px 5px white", // White shadow
              display: "flex", // To center content (if needed)
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Groups2 sx={{ color: "white", fontSize: 40 }} />
            {/* Optional content inside the circle */}
          </Box>
          <Typography variant="h4" sx={{color: "#13216e", fontSize: "18px",margin:'10px',fontWeight:'600'}}>
          Total Users</Typography>
          <Typography variant="h4" color="black" sx={{color: "#4e0dff", fontSize: "30px"}}>
            {investor.TotalInvestors}
          </Typography>
        </Paper>
      </Grid>
      <Grid item xs={6} md={3}>
        <Paper
          elevation={3}
          sx={{
            padding: 2,
            background: "linear-gradient(to bottom, #FEF8F6, #FFFFFF)",
            //   background: "#FEF8F6",
            display: "flex", // Use flexbox
            flexDirection: "column", // Align items in a column
            alignItems: "center", // Horizontally center the content
            justifyContent: "center", // Vertically center the content
            textAlign: "center", // Center-align text
          }}
        >
          <Box
            sx={{
              width: 70, // Diameter of the circle
              height: 70,
              borderRadius: "50%", // Makes it a circle
              backgroundColor: "#EE7D5F",
              boxShadow: "0 0 10px 5px white", // White shadow
              display: "flex", // To center content (if needed)
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <HouseOutlined sx={{ color: "white", fontSize: 40 }} />
            {/* Optional content inside the circle */}
          </Box>
          <Typography variant="h4" sx={{color: "#13216e", fontSize: "18px",margin:'10px',fontWeight:'600'}}>
          Properties Listed</Typography>
          <Typography variant="h4" color="#EE7D5F">
            {investor.PropertyListed}
          </Typography>
        </Paper>
      </Grid>

      <Grid item xs={12} md={5}>
        <Paper
          elevation={3}
          sx={{
            padding: 2,
            background: "linear-gradient(to bottom, #F7FAFD, #FFFFFF)",
            //   background: "#F7FAFD",
            display: "flex", // Use flexbox
            flexDirection: "row", // Align content in a row
            alignItems: "center", // Align items vertically
            textAlign: "left", // Align text
            gap: 2, // Add spacing between items
          }}
        >
          {/* Left: Details */}
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              flex: 1, // Take up remaining space
            }}
          >
            {/* Icon */}
            <Box
              sx={{
                width: 70,
                height: 70,
                borderRadius: "50%",
                backgroundColor: "#435084",
                boxShadow: "0 0 10px 5px white",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                marginBottom: 2,
              }}
            >
              <CurrencyRupee sx={{ color: "white", fontSize: 40 }} />
            </Box>

            {/* Text Details */}
          <Typography variant="h4" sx={{color: "#13216e", fontSize: "18px",fontWeight:'600'}}>
              Total Investments
            </Typography>
            <Typography variant="h4" color="#67AD5B">
              €{investor.TotalInvestedAmount}
            </Typography>
          </Box>

          {/* Right: Pie Chart */}
          <Box
            sx={{
              width: 120,
              height: 120,
            }}
          >
            <Pie data={pieData} options={pieOptions} />
          </Box>
        </Paper>
      </Grid>
    </Grid>

     {/* Investment Trends Chart */}
          <Box sx={{ marginTop: 4 }}>
            <Paper elevation={6} sx={{ padding: 3 }}>
            <Grid container spacing={6}>
            <Grid item xs={6} md={6}>
            <Typography variant="h6" sx={{color:'#13216e',fontWeight:'600',fontSize:'20px' }} >
                Investment Trends
              </Typography>
              <Line data={chartData} options={chartOptions} />
              </Grid>
              <Grid item xs={6} md={6}>
              <Typography variant="h6" sx={{color:'#13216e',fontWeight:'600',fontSize:'20px' }}>
                Recent Investment
              </Typography>
              <DataGrid
  rows={rows}  
  columns={columns}
  pageSizeOptions={[5, 10, 15, 20]}  // Ensure correct prop
  initialState={{
    pagination: { paginationModel: { pageSize: 5 } }  // Set default page size
  }}
  pagination
  disableSelectionOnClick
  autoHeight={false}
/>


              </Grid>
              </Grid>
              
            </Paper>
          </Box>

          <Box sx={{ marginTop: 4 }}>
            
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingBottom: 4 }}>
  <Typography variant="h6" gutterBottom sx={{ color: '#13216e', fontWeight: '600', fontSize: '20px' }}>
    Property Insights
  </Typography>
  <Button onClick={handleViewAllClick} variant="contained" sx={{ marginLeft: 2 }}>
    {showAll ? 'Show Less Properties' : 'View All Properties'}
  </Button>
</Box>




<Grid container spacing={4}>
  {propertiesToDisplay.map((property, index) => (
    <Grid item xs={12} sm={6} md={4} key={index}>
      <Card sx={{ borderRadius: 2, boxShadow: 3 }}>
        {/* Wrap CardContent with CardActionArea to make it clickable */}
        <CardActionArea onClick={() => handleCardClick(property)}>
          <CardMedia
            component="img"
            height="200"
            image={property.iconUrl}
            alt={property.name}
            style={{ objectFit: 'cover' }}
          />
          <CardContent>
            <Typography variant="h6" sx={{ color: '#13216e', fontWeight: 600, fontSize: '20px' }}>
              {property.name}
            </Typography>
            <Typography variant="body2" sx={{ color: '#4e0dff', fontWeight: 600, fontSize: '16px' }}>
              {property.address}
            </Typography>
            <Typography variant="body2" sx={{ color: 'gray', fontWeight: 500 }}>
              Investors: {property.noOfInvestors}
            </Typography>

            <Box sx={{ marginTop: 2 }}>
              <Typography variant="body2" sx={{ color: '#13216e', fontWeight: 600, fontSize: '16px' }}>
                Investment Progress
              </Typography>
              <LinearProgress
                variant="determinate"
                value={property.investmentPercentage * 100} 
                sx={{ height: 8, borderRadius: 5 }}
              />
              <Typography variant="caption" display="block">
                {Math.round(property.investmentPercentage * 100)}%
              </Typography>
            </Box>
          </CardContent>
        </CardActionArea>
      </Card>
    </Grid>
  ))}
</Grid>

     
    </Box>
    </Box>
  );
};

export default Income;
